import React from 'react';
import PropTypes from 'prop-types';
import { VehicleEntities } from 'client/data/models/vehicle-v2';

export const FEATURES_PRIORITY = [
  'back-up-camera',
  'blind-spot-monitoring',
  'automatic-emergency-braking',
  'lane-departure-warning',
  'parking-sensors',
  '360-degree-camera',
  'alarm',
  'tire-pressure-warning',
  'stability-control',
  'pre-collision-safety-system',
  'heads-up-display',
  'occupant-sensing-airbag',
  'post-collision-safety-system',
];
const MAX_FEATURES_NUM = 10;

export function SafetyGenericFeatures({ safetyGenericFeatures, modelName }) {
  const displayFeatures = safetyGenericFeatures
    .sort(
      ({ niceId: niceIdA }, { niceId: niceIdB }) =>
        FEATURES_PRIORITY.indexOf(niceIdA) - FEATURES_PRIORITY.indexOf(niceIdB)
    )
    .slice(0, MAX_FEATURES_NUM);

  return (
    <div className="safety-generic-features">
      <div className="mb-1">Key safety features on the {modelName} include:</div>
      <ul className="ps-2 mb-1_5">
        {displayFeatures.map(({ niceId, displayName }) => (
          <li key={niceId} className="mb-0_5">
            {displayName}
          </li>
        ))}
      </ul>
    </div>
  );
}

SafetyGenericFeatures.propTypes = {
  modelName: PropTypes.string.isRequired,
  safetyGenericFeatures: PropTypes.arrayOf(VehicleEntities.GenericFeature).isRequired,
};
